<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Cadastro de Usuário Operadora</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="usuarioForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="nome">Nome</label>
                  <input type="text" class="form-control" id="nome" formControlName="nome" [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="login">Login</label>
                  <input type="text" class="form-control" id="login" formControlName="login" [readonly]="!isEditing">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="cnpj">CNPJ</label>
                  <input type="text" class="form-control" id="cnpj" formControlName="cnpj" [readonly]="!isEditing">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="digital">Digital</label>
                  <input type="file" class="form-control" id="digital" (change)="onFileSelected($event)" [disabled]="!isEditing">
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-12">
                <button type="button" class="btn btn-primary mr-2" (click)="toggleEdit()">
                  {{ isEditing ? 'Cancelar Cadastro' : 'Adicionar Novo' }}
                </button>
                <button type="submit" class="btn btn-success" [disabled]="!isEditing || !usuarioForm.valid">
                  Salvar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela de Usuários -->
  <div class="row mt-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Operadoras Cadastradas</h4>
        </div>
        <div class="card-body">
          <table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>CNPJ</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let usuario of usuarios">
                <td>{{ usuario.id }}</td>
                <td>{{ usuario.nome }}</td>
                <td>{{ usuario.cnpj }}</td>
                <td>
                  <span [class]="usuario.ativo ? 'badge badge-success' : 'badge badge-danger'">
                    {{ usuario.ativo ? 'Ativo' : 'Inativo' }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-primary mr-1" (click)="editarUsuario(usuario)">
                    <i class="feather icon-edit"></i>
                  </button>
                  <button class="btn btn-sm" [class]="usuario.ativo ? 'btn-warning' : 'btn-success'" (click)="inativarUsuario(usuario)">
                    <i class="feather" [class]="usuario.ativo ? 'icon-user-x' : 'icon-user-check'"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div> 